<div class="md-modal">
  <div class="md-body">
    <h3>{{ question }}</h3>

    <div *ngIf="showNotifyClientOption" class="text-center custom-control custom-checkbox">
      <input [(ngModel)]="notifyClient" type="checkbox" class="custom-control-input" id="notifyClient" />
      <label class="custom-control-label" for="notifyClient">
        {{ 'SHARED.createBookingModal.notifyClient' | translate }}
      </label>
    </div>
  </div>

  <div class="md-actions">
    <button class="btn btn-md btn-outline" (click)="close(false)">{{ 'GENERAL.no' | translate }}</button>
    <button class="btn btn-md btn-success" (click)="close(true)">{{ 'GENERAL.yes' | translate }}</button>
  </div>

</div>
